"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-danger */
const react_1 = __importDefault(require("react"));
const react_slick_1 = __importDefault(require("react-slick"));
const Message_1 = require("../message/Message");
const prop_types_1 = __importStar(require("prop-types"));
const BonusSectionStyled_1 = __importDefault(require("./BonusSectionStyled"));
const prevArrow = (react_1.default.createElement("div", { className: "prev-arrow" },
    react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 38 38" },
        react_1.default.createElement("path", { d: "M.053 19C.053 8.536 8.536.053 19 .053c8.715 0 16.055 5.883 18.266 13.894l-20.792 1.895 6-5.684-5.053-5.053L4.79 18.368 17.42 32.895l5.053-5.053-6-6 21.156.632C35.998 31.279 28.278 37.947 19 37.947 8.536 37.947.053 29.464.053 19z" }))));
const nextArrow = (react_1.default.createElement("div", { className: "next-arrow" },
    react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 38 38" },
        react_1.default.createElement("path", { d: "M37.947 19C37.947 8.536 29.464.053 19 .053 10.285.053 2.945 5.936.734 13.947l20.792 1.895-6-5.684 5.053-5.053L33.21 18.368 20.58 32.895l-5.053-5.053 6-6-21.156.632C2.002 31.279 9.722 37.947 19 37.947c10.464 0 18.947-8.483 18.947-18.947z" }))));
const sliderSetting = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    prevArrow,
    nextArrow
};
const getImage = keyImages => {
    const image = keyImages ? keyImages.find(image => image.type === 'Thumbnail') : null;
    return image ? image.url : 'https://cdn2-unrealengine-1251447533.file.myqcloud.com/fn-nav-logo-3e6bd67b98b0.svg';
};
const BonusSection = ({ show, bonusOffers, header, subtitle, notice }) => {
    if (!show || !bonusOffers)
        return null;
    sliderSetting.infinite = bonusOffers.length > 1;
    const slideBox = (react_1.default.createElement(react_slick_1.default, Object.assign({}, sliderSetting), bonusOffers.map(offer => {
        const { title, keyImages, id } = offer;
        const imageUrl = getImage(keyImages);
        return (react_1.default.createElement("div", { className: "bonus-slider-box", key: id },
            react_1.default.createElement("img", { src: imageUrl, className: "bonus-item-img", alt: title }),
            react_1.default.createElement("h5", { className: "bonus-item-title" }, title)));
    })));
    return (react_1.default.createElement(BonusSectionStyled_1.default, { className: "ecrp-bonus-wrapper" },
        react_1.default.createElement("div", { className: "ecrp-bonus-content" },
            react_1.default.createElement("h2", null, Message_1.localizedMessage(header)),
            subtitle && react_1.default.createElement("h4", null, Message_1.localizedMessage(subtitle)),
            slideBox,
            react_1.default.createElement("div", { className: "ecrp-bonus-notice" },
                react_1.default.createElement("h5", null, Message_1.localizedMessage(notice))))));
};
BonusSection.propTypes = {
    bonusOffers: prop_types_1.default.array,
    show: prop_types_1.default.bool,
    header: prop_types_1.string,
    subtitle: prop_types_1.string,
    notice: prop_types_1.string
};
exports.default = BonusSection;
//# sourceMappingURL=BonusSection.js.map